import { Link } from "react-router-dom";

const ConectionLogo = () => {
  return (
    <Link style={{ width: "100%", height: "100%" }} to={"/events-listing"}>
      <svg
        width="200"
        height="57"
        viewBox="0 0 267 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_18_610)">
          <path
            d="M80.2516 53.0386C80.2516 55.2874 78.035 56.8958 74.0107 56.8958C71.2372 56.8958 68.7849 56.0841 66.9409 54.4949L68.2088 53.0579C69.8151 54.4949 71.7105 55.1375 74.0942 55.1375C76.7328 55.1375 78.187 54.4435 78.187 53.2099C78.187 51.9763 76.6986 51.67 73.7216 51.4173C70.4576 51.1475 67.3778 50.4193 67.3778 48.0013C67.3778 45.5833 70.1021 44.3475 73.501 44.3475C76.071 44.3475 78.2534 45.1078 79.6755 46.3093L78.3905 47.695C77.1719 46.6285 75.4971 46.123 73.5353 46.1059C71.657 46.0887 69.4253 46.5449 69.4253 47.8642C69.4253 49.115 71.4043 49.3356 73.9914 49.539C77.6795 49.826 80.2495 50.5713 80.2495 53.0407L80.2516 53.0386Z"
            fill="#EF7A4C"
          />
          <path
            d="M92.1082 53.6832H84.5137L83.008 56.5424H80.8085L87.2186 44.703H89.4503L95.8433 56.5424H93.6266L92.1039 53.6832H92.1082ZM91.2129 51.957L88.3195 46.4763L85.4282 51.957H91.2129Z"
            fill="#EF7A4C"
          />
          <path
            d="M110.799 44.701V56.5404H109.006L99.754 51.2803V56.5404H97.7922V48.7767H99.9575L108.82 53.6812V44.6989H110.799V44.701Z"
            fill="#EF7A4C"
          />
          <path
            d="M125.703 46.4764H120.308V56.5403H118.278V46.4764H112.917V44.7009H125.705V46.4764H125.703Z"
            fill="#EF7A4C"
          />
          <path
            d="M135.581 53.6832H127.986L126.48 56.5424H124.281L130.691 44.703H132.923L139.316 56.5424H137.099L135.576 53.6832H135.581ZM134.683 51.957L131.792 46.4763L128.898 51.957H134.683Z"
            fill="#EF7A4C"
          />
          <path
            d="M154.271 44.7009V56.5403H152.479L143.226 47.2046V56.5403H141.265V44.7009H143.43L152.292 53.6832V44.7009H154.271Z"
            fill="#EF7A4C"
          />
          <path
            d="M171.051 50.6206C171.051 54.2744 168.244 56.5403 163.847 56.5403H157.841V44.7009H163.847C168.244 44.7009 171.051 46.9669 171.051 50.6206ZM168.97 50.6206C168.97 47.8792 166.804 46.4764 163.693 46.4764H159.87V54.7648H163.693C166.804 54.7648 168.97 53.3598 168.97 50.6206Z"
            fill="#EF7A4C"
          />
          <path
            d="M185.598 54.7648V56.5403H173.808V44.7009H185.429V46.4764H175.821V49.6397H183.906V51.4152H175.821V54.7648H185.598Z"
            fill="#EF7A4C"
          />
          <path
            d="M198.943 56.5403L195.272 52.244H190.282V56.5403H188.251V44.7009H196.302C199.059 44.7009 201.089 46.0202 201.089 48.4725C201.089 50.5199 199.669 51.7707 197.604 52.1434L201.444 56.5403H198.941H198.943ZM196.169 50.5028C197.861 50.5028 199.011 49.961 199.011 48.4896C199.011 47.0183 197.861 46.4764 196.169 46.4764H190.267V50.5028H196.169Z"
            fill="#EF7A4C"
          />
          <path
            d="M35.0381 26.8391C35.3915 19.7544 41.1912 15.7215 49.8501 16.1542C58.509 16.5868 63.8783 21.1765 63.5249 28.2612C63.1715 35.346 57.3718 39.3767 48.7129 38.9441C40.054 38.5114 34.6847 33.9239 35.0381 26.8391ZM54.005 27.7858C54.1314 25.2371 52.2574 23.6394 49.4839 23.5024C46.7468 23.3653 44.6865 24.766 44.558 27.3146C44.4316 29.8632 46.3441 31.4609 49.0791 31.598C51.8526 31.7372 53.8765 30.3344 54.0029 27.7858H54.005Z"
            fill="#F2C50C"
          />
          <path
            d="M25.5953 27.9999L34.4748 32.6966C32.029 37.0379 25.9894 40.1947 18.1764 40.1947C7.67991 40.1947 0.181793 34.9454 0.181793 25.4362C0.181793 15.9271 7.67991 10.6777 18.5705 10.6777C25.9894 10.6777 31.9476 13.9139 34.3163 18.0966L25.4368 22.7934C23.8198 20.3475 21.4125 19.1246 18.412 19.1246C14.2292 19.1246 11.3872 21.4912 11.3872 25.4384C11.3872 29.3855 14.2292 31.7521 18.412 31.7521C21.4104 31.7521 23.8969 30.6085 25.5931 28.002L25.5953 27.9999Z"
            fill="#F2C50C"
          />
          <path
            d="M66.4441 39.248V17.1499H77.0991V20.0691C79.1123 17.5825 81.7958 16.3596 85.229 16.3596C91.305 16.3596 94.8966 20.3453 94.8966 25.948V39.2459H84.2416V26.5777C84.2416 24.9993 83.1365 23.8556 81.3225 23.8556C79.8618 23.8556 78.5211 24.5666 77.0991 26.4599V39.2459H66.4441V39.248Z"
            fill="#F2C50C"
          />
          <path
            d="M114.155 33.1593C117.23 33.0136 118.815 32.3069 120.762 30.8719L126.048 35.7186C122.949 38.7084 118.779 39.8949 113.891 40.1262C104.037 40.5931 98.1113 36.4082 97.7558 28.878C97.4046 21.4291 102.827 16.6296 111.932 16.1991C119.777 15.8286 126.146 19.3988 126.515 27.1646C126.566 28.2676 126.485 29.0236 126.32 29.7025L107.912 30.5721C108.764 32.7052 110.846 33.3177 114.157 33.1614L114.155 33.1593ZM107.805 25.8368L116.909 25.4063C116.159 23.7422 114.695 22.8641 112.33 22.9754C110.122 23.0804 108.464 23.9478 107.805 25.8368Z"
            fill="#F2C50C"
          />
          <path
            d="M154.342 26.9975L163.718 30.602C161.806 35.2024 156.188 39.0575 148.431 39.9891C138.009 41.2399 129.939 36.9222 128.806 27.4794C127.673 18.0366 134.493 11.9328 145.306 10.6349C152.671 9.75035 158.974 12.254 161.823 16.1241L153.567 21.8446C151.669 19.6086 149.133 18.6813 146.154 19.0389C142.001 19.538 139.461 22.2258 139.932 26.1451C140.404 30.0623 143.505 32.0755 147.66 31.5765C150.637 31.2188 152.969 29.786 154.344 26.9975H154.342Z"
            fill="#EF7A4C"
          />
          <path
            d="M190.093 39.2481V10.1466H201.142V39.2481H190.093Z"
            fill="#EF7A4C"
          />
          <path
            d="M169.235 39.2481V21.6562L180.284 18.7542V39.2481H169.235Z"
            fill="#EF7A4C"
          />
          <path
            d="M237.729 39.248V17.1499H248.384V20.0691C250.397 17.5825 253.081 16.3596 256.514 16.3596C262.59 16.3596 266.182 20.3453 266.182 25.948V39.2459H255.527V26.5777C255.527 24.9993 254.422 23.8556 252.608 23.8556C251.147 23.8556 249.806 24.5666 248.384 26.4599V39.2459H237.729V39.248Z"
            fill="#F2C50C"
          />
          <path
            d="M187.061 9.88538H163.515V18.5871H187.061V9.88538Z"
            fill="#EF7A4C"
          />
          <path
            d="M233.219 3.12822C229.276 7.75002 223.669 10.5449 217.625 11.1703C217.565 11.1768 217.503 11.1832 217.443 11.1896C209.827 12.072 204.079 18.8441 204.445 26.5028C204.85 34.984 212.339 41.3705 220.778 40.4346C228.398 39.5886 234.178 32.8465 233.851 25.1878C233.848 25.1257 233.844 25.0657 233.842 25.0036C233.508 18.9383 235.384 12.9587 239.327 8.33685L240.704 6.722C242.143 5.03648 241.942 2.5007 240.254 1.06361C238.569 -0.375614 236.035 -0.174293 234.596 1.51123M225.828 26.1537C225.686 29.1521 223.478 31.7414 220.538 32.3539C216.227 33.2535 212.254 29.8653 212.461 25.4641C212.603 22.4657 214.811 19.8764 217.751 19.2638C222.063 18.3643 226.036 21.7525 225.828 26.1537Z"
            fill="#F2C50C"
          />
        </g>
        <defs>
          <clipPath id="clip0_18_610">
            <rect
              width="266"
              height="56.7916"
              fill="white"
              transform="translate(0.181824 0.104126)"
            />
          </clipPath>
        </defs>
      </svg>
    </Link>
  );
};

export default ConectionLogo;
